// extracted by mini-css-extract-plugin
export var measureBox = "_a5-0";